import { FileWithPath } from '@mantine/dropzone'
import { rootApi } from '@v2/store/api/rootApi'
import axios, { AxiosError } from 'axios'

interface FormAttachmentsResponse {
  url?: string
  error?: string
  success: boolean
}

export const formAttachmentsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getPreSignedUrl: builder.query<FormAttachmentsResponse[], FileWithPath[]>({
      queryFn: async (files, _api, _extraOptions, baseQuery) => {
        const preSignedUrls = await Promise.all(
          files.map(
            (file) =>
              baseQuery({
                url: `/v1/forms/attachment/generate-presigned-url?contentType=${encodeURIComponent(
                  file.type,
                )}`,
                method: 'GET',
              }) as Promise<{
                data?: string
                error?: { data: { message: string } }
              }>,
          ),
        )
        const data = await Promise.all(
          preSignedUrls.map((urlResponse, idx) => {
            if (urlResponse.error) {
              return urlResponse.error.data?.message || 'Error'
            }
            try {
              return axios.put<{ config: { url: string } }>(
                urlResponse.data as string,
                files[idx],
                {
                  headers: {
                    'Content-Type': files[idx].type,
                  },
                },
              )
            } catch (error) {
              const axiosError = error as AxiosError
              return axiosError
            }
          }),
        )

        return {
          data: data.map((response) =>
            typeof response === 'string'
              ? { error: response, success: false }
              : axios.isAxiosError(response)
              ? { error: response.response, success: false }
              : { url: response.config.url?.split('?')[0], success: true },
          ) as FormAttachmentsResponse[],
        }
      },
    }),
    deleteFormAttachments: builder.mutation<string, string>({
      query: (id: string) => ({
        url: `/v1/forms/attachment/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const { useLazyGetPreSignedUrlQuery, useDeleteFormAttachmentsMutation } =
  formAttachmentsApi
